// ActivitiesListPage: not built yet, so it says so instead of showing sample content.
import React from "react";
import { ComingSoon } from "../components/ui";

const ActivitiesListPage = () => <ComingSoon title="Activities" description="Manage guest activities here." />;

export default ActivitiesListPage;
